import { AdminTenant } from '@hakimo-ui/hakimo/types';
import { Label, Tooltip } from '@hakimo-ui/shared/ui-base';
import {
  CubeIcon,
  MapPinIcon,
  SpeakerWaveIcon,
  VideoCameraIcon,
} from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

interface Props {
  tenant: AdminTenant;
}

export function TenantCard(props: Props) {
  const { tenant } = props;
  const displayProductType =
    tenant.productType === 'Motion' ? 'Remote Guarding' : tenant.productType;

  return (
    <Link
      to={tenant.id}
      className="dark:bg-ondark-bg-2 bg-onlight-bg-2 dark:hover:bg-ondark-bg-3 hover:bg-onlight-bg-3 relative block rounded-lg p-4 text-left shadow-sm"
    >
      {!tenant.isActive && (
        <div className="absolute right-4 top-4">
          <Label text="Inactive" small />
        </div>
      )}
      <h3 className="dark:text-ondark-text-1 text-onlight-text-1 text-sm font-semibold">
        {tenant.name}
      </h3>
      <p className="dark:text-ondark-text-2 text-onlight-text-2 mt-1 text-xs">
        {tenant.id}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-between gap-y-2 px-2 pb-1">
        <div className="flex items-center gap-1">
          <CubeIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
          <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
            {displayProductType}
          </span>
        </div>
        <div className="flex flex-wrap gap-x-5">
          <div className="flex items-center gap-1">
            <Tooltip text="Locations" position="bottom">
              <MapPinIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
            </Tooltip>
            <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
              {tenant.locationCount}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <Tooltip text="Cameras" position="bottom">
              <VideoCameraIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
            </Tooltip>
            <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
              {tenant.cameraCount}
            </span>
          </div>
          <div className="flex items-center gap-1">
            <Tooltip text="Audio Devices" position="bottom">
              <SpeakerWaveIcon className="dark:text-ondark-text-2 text-onlight-text-2 h-4 w-4" />
            </Tooltip>
            <span className="dark:text-ondark-text-2 text-onlight-text-2 text-xs">
              {tenant.audioDeviceCount}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default TenantCard;
